module.exports = __webpack_public_path__ + "static/media/btn-left-disabled.08141570.svg";